<template>
    <div class="home">
        <sec-music />
        <sec-booth />
        <sec-product />
        <sec-schedule />
        <sec-video />
    </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from "@/components/HelloWorld.vue"
import SecMusic from "@/components/SecMusic.vue"
import SecBooth from "@/components/SecBooth.vue"
import SecProduct from "@/components/SecProduct.vue"
import SecSchedule from "@/components/SecSchedule.vue"
import SecVideo from "@/components/SecVideo.vue"

export default {
    name: "home",
    data() {
        return {

        }
    },
    methods: {

    },
    computed: {
        swiper() {
            return this.$refs.mySwiper.swiper
        }
    },
    components: {
        SecMusic,
        SecBooth,
        SecProduct,
        SecSchedule,
        SecVideo
    }
}
</script>

<style lang="scss" scoped>
.home {
    overflow: hidden;
    
    &>div {
        margin-top: 70px;

        &:first-child {
            // margin-top: 0;
        }
    }
}

@media all and (max-width: 1024px) {

.home {
    &>div {
        margin-top: 20% !important;

        &:first-child {
            // margin-top: 0 !important;
        }
    }
}


}

</style>